import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter, Redirect} from 'react-router-dom';

import Box from 'components/box';
import {SearchFail, Select, Label, UniversalSelectWrapper, UniversalSearchWrapper} from 'components/common';
import InstitutionsList from './institutions-list';
import Spinner from 'spinner';
import Pagination from 'pagination';
import {ButtonDefault, LinkDefault} from 'components/buttons';
import {PageHead} from 'components/header/components';
import Input from 'form/input';

import {searchInstitutionsByLevel, loadStaffByUser, loadAllTypes, cleanCurrentUserInstitutions} from '../../redux/actions/portal/institutions';

const mapStateToProps = (state) => ({
  institutions: state.institutions.get('institutionsList'),
  isFetching: state.institutions.get('institutionsIsLoading'),
  user: state.auth.get('user'),
  staff: state.institutions.get('currentUserInstitutions'),

  allTypes: state.institutions.get('allTypes'),
  allTypesAreLoading:  state.institutions.get('allTypesAreLoading')
});

const mapDispatchToProps = (dispatch) => ({
  onSearch: (name, type, offset, id) => dispatch(searchInstitutionsByLevel(name, type, 2, 10, offset, id)),
  loadStaff: (id, role) => dispatch(loadStaffByUser(id, role)),
  onLoad: () => dispatch(loadAllTypes())
});


const types = allTypes => {
  return allTypes.filter(function(el) {
   if (el.get('code').slice(4,6) === "00"){
     return el;
   }
 })
}

class InstitutionsAll extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: '',
      page: 1,
      offset: 10,
      type: ""
    }

    this.changeSearchName = this.changeSearchName.bind(this);
    this.onChangeType = this.onChangeType.bind(this);
  }

  changeSearchName(event) {
    this.setState({
      name: event.target.value
    })
  }

  onChangeType(event){
    this.setState({
        type: event.target.value
    })
}

  handleSearch = event => {
    event.preventDefault();
    const isAdminInstitution = this.props.user && this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser')
    if(isAdminInstitution) {
      this.props.match.params.page != 1
        ? this.props.history.push(`/admin/institutions/1`)
        : this.props.onSearch(this.state.name, this.state.type, 0, this.props.user.get('id'))
    } else {
      this.props.match.params.page != 1
        ? this.props.history.push(`/admin/institutions/1`)
        : this.props.onSearch(this.state.name, this.state.type, 0)
    }
  }

  redirectIfAdmin = () => {
    const isAdminInstitution = this.props.user && this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser')
    if(isAdminInstitution && this.props.staff && this.props.staff.get('results') && this.props.staff.getIn(['results', 0, 'institution'])) {
      console.log(this.props.staff.getIn(['results', 0, 'institution']))
      return <Redirect from='/admin/'
                       to={`/admin/institutions/detail/${this.props.staff.getIn(['results', 0, 'institution'])}`} />
    }
  }

  componentDidMount() {
    this.props.onLoad()
    const page = this.props.match.params.page || 1;
    const offset = 10 * (page - 1);
    this.setState(() => ({ page, offset }));

    const isAdminInstitution = this.props.user && this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser')
    if(isAdminInstitution) {
      this.props.onSearch(this.state.name, this.state.type, offset, this.props.user.get('id'))
      this.props.loadStaff(this.props.user.get('id'), 'is_admin')
    } else {
      this.props.onSearch(this.state.name, this.state.type, offset)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.page !== nextProps.match.params.page) {
      const page = nextProps.match.params.page || 1;
      const offset = 10 * (page - 1);
      this.setState(() => ({ page, offset }))

      const isAdminInstitution = nextProps.user && nextProps.user.get('is_admin_institution') && !nextProps.user.get('is_superuser')
      if(isAdminInstitution){
        this.props.onSearch(this.state.name, this.state.type, offset, nextProps.user.get('id'))
      } else {
        this.props.onSearch(this.state.name, this.state.type, offset)
      }

      if(isAdminInstitution && !nextProps.staff) {
        nextProps.loadStaff(nextProps.user.get('id'), 'is_admin')
      }

    }
  }
	render() {

    if (!this.props.institutions || this.props.allTypesAreLoading) return <Spinner />

    if (this.props.allTypesAreLoading){
      return <Spinner/>
    }

		return (
      <div>
			<Box>
				<PageHead>
					<h2>Реєстр установ</h2>
					<LinkDefault to="/admin/institutions/create">Створити установу</LinkDefault>
				</PageHead>

        <UniversalSearchWrapper onSubmit={this.handleSearch}>
          <Input
            block
            placeholder="Введіть назву або код ЄДРПОУ установи"
            label="Пошук за назвою або кодом ЄДРПОУ установи"
            value={this.state.name}
            onChange={this.changeSearchName}
          />
        <UniversalSelectWrapper>
          <Label>Тип установи</Label>
          <Select value={this.state.type} onChange={this.onChangeType}>
            <option defaultValue value="">Всі типи</option>
            {types(this.props.allTypes.get('results')).map((item, i) => (
              <option key={i} value={item.get('code')}>{item.get('code')} {item.get('title')}</option>
            ))}
          </Select>
        </UniversalSelectWrapper>

          <ButtonDefault type="submit" value="Пошук" />
        </UniversalSearchWrapper>



				{this.props.institutions.get('results').size > 0
						? (<div>
							{
								this.props.isFetching
									? (<Spinner/>)
									: (<InstitutionsList institutions={this.props.institutions.get('results')}/>)
							}

						</div>)
						: (
							<SearchFail>Установи відсутні</SearchFail>
						)}

				<Pagination counts={this.props.institutions.get('count')} path={`/admin/institutions/`} matched={this.props.match.params.page} limits={10}/>
			</Box>

        {this.redirectIfAdmin()}
		</div>
  )
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InstitutionsAll));



// WEBPACK FOOTER //
// ./src/admin/institutions/institutions.js